import { render, staticRenderFns } from "./Result.Detail.vue?vue&type=template&id=791bd5d8&"
import script from "./Result.Detail.vue?vue&type=script&lang=js&"
export * from "./Result.Detail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports